/** 曜日の番号（ISO 8601。1 = 月 〜 7 = 日）と表示名。 */
export const WEEKDAYS = [
  { value: 1, label: '月' },
  { value: 2, label: '火' },
  { value: 3, label: '水' },
  { value: 4, label: '木' },
  { value: 5, label: '金' },
  { value: 6, label: '土' },
  { value: 7, label: '日' },
] as const;

/** タブ行のチップに並べる曜日の数。これを超える分は「…」で省略する。 */
const SHORT_WEEKDAY_COUNT = 2;

function weekdayLabels(weekdays: number[]): string[] {
  return WEEKDAYS.filter((day) => weekdays.includes(day.value)).map((day) => day.label);
}

/** 定期更新の曜日を月曜始まりの順に中黒でつなぐ（例: 「月・木・日」）。 */
export function formatWeekdays(weekdays: number[]): string {
  return weekdayLabels(weekdays).join('・');
}

/** タブ行のチップに出す短い曜日（例: 「月・木」「月・火…」）。 */
export function formatWeekdaysShort(weekdays: number[]): string {
  const labels = weekdayLabels(weekdays);
  const shown = labels.slice(0, SHORT_WEEKDAY_COUNT).join('・');
  return labels.length > SHORT_WEEKDAY_COUNT ? `${shown}…` : shown;
}
